<template>
    <div class="tsa-productionTeam">
        <div class="title">
            <p>制作团队</p>
        </div>
        <div class="info">
            <div class="item">
                <div class="name">
                    <p>制作机构</p>
                </div>
                <p class="value">{{ result.productionCompany }}</p>
            </div>
            <div class="item">
                <div class="name">
                    <p>制片人</p>
                </div>
                <p class="value">{{ result.producer }}</p>
            </div>
            <div class="item">
                <div class="name">
                    <p>导演</p>
                </div>
                <p class="value">{{ result.director }}</p>
            </div>
            <div class="item">
                <div class="name">
                    <p>演员</p>
                </div>
                <p class="value">{{ result.actors }}</p>
            </div>
            <div class="item">
                <div class="name">
                    <p>制作金额</p>
                </div>
                <p class="value">{{ result.productionCost | mapFilter(productionCostList) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import productionCostList from '@/config/copyright/productionCost'
export default {
    props: {
        result: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            productionCostList
        }
    }
}
</script>

<style lang="scss" scoped>
    @import './css/mobile.scss';

</style>